<template>
  <mped-cost-view-component :is-plan="true"></mped-cost-view-component>
</template>

<script>
export default  {
  name: 'mped-cost-planning-view'
}
</script>

<script setup>
import MpedCostViewComponent from '@/views/mped/components/mped-cost-view-component.vue';
</script>
